import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForChooseYourEdition(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInCollection, isInTrial } = context;

	return (
		!isInCollection &&
		product === 'confluence' &&
		edition === 'free' &&
		!isInTrial &&
		fg('confluence_free_choose_your_edition_kill_switch')
	);
}
